import * as yup from 'yup'

export default yup.string().required('此為必填欄位')
// .matches(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]){8,10}$/, '需擁有1個英文字母、1個數字、8個字元')
